import { ceil } from "./math";


export const MAP_PADDING            = ceil(1 / 18, 3)
export const WHEEL_ZOOM_SENSITIVITY = 0.002
export const MAX_SCALE              = 4

export const GAME_MAP_SQUARE_SIZE: number = 87.5
export const GAME_MAP_SIZE: number        = 1400